<div class="table-container">

  <!-- ── Header ─────────────────────────────────────────────────── -->
  <div class="panel-header">
    <div class="panel-header__titles">
      <span class="panel-header__eyebrow">Administration</span>
      <h2 class="panel-header__org">{{ orgName || '—' }} — User Permissions</h2>
    </div>


  </div>

  <div class="actions-bar">

    <button mat-button (click)="onInviteUser()" [disabled]="loading">
      <mat-icon>person_add</mat-icon>
      Invite User
    </button>

    <button mat-raised-button color="primary" (click)="submitChanges()" [disabled]="!hasPendingChanges || saving">
      <mat-spinner *ngIf="saving" diameter="18" style="display:inline-flex; margin-right: 6px;"></mat-spinner>
      <mat-icon *ngIf="!saving">save</mat-icon>
      {{ saving ? 'Saving…' : 'Update Permissions' }}
    </button>

  </div>

  <!-- ── Search bar ─────────────────────────────────────────────── -->
  <div style="display: flex; flex-direction: row; align-items: center;">
    <mat-form-field appearance="fill" class="filter-field">
      <mat-label>Search users</mat-label>
      <input type="text" matInput [(ngModel)]="searchQuery" placeholder="e.g. Name, Mail" />
    </mat-form-field>
    <span class="example-spacer"></span>
    <button mat-icon-button matTooltip="Reload" (click)="loadPermissionsThenData()" [disabled]="loading || saving">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <!-- ── Loading spinner ────────────────────────────────────────── -->
  <div class="loading-wrapper" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <!-- ── Permission grid ────────────────────────────────────────── -->
  <div class="table-wrapper" *ngIf="!loading && permissions.length != 0">
    <table class="perm-grid ticket-table" aria-label="User permission matrix">

      <thead>
        <tr>
          <th class="perm-grid__user-col">User</th>
          <ng-container *ngFor="let perm of permissions; let i = index">
            <!-- Vertical separator between category blocks -->
            <th class="perm-grid__perm-col" [matTooltip]="perm.key" matTooltipPosition="above">
              {{ perm.label }}
            </th>
          </ng-container>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let row of filteredRows" class="perm-grid__row">

          <!-- User info cell -->
          <td class="perm-grid__user-cell">
            <div class="perm-grid__user-info">
              <div class="avatar">{{ row.usr_name.charAt(0).toUpperCase() }}</div>
              <div class="perm-grid__user-details">
                <span class="perm-grid__user-name">{{ row.usr_name }}</span>
                <span class="perm-grid__user-mail">{{ row.usr_mail }}</span>
              </div>

              <button mat-icon-button class="perm-grid__delete-btn" matTooltip="Remove user from organization"
                (click)="onDeleteUser(row); $event.stopPropagation()">
                <mat-icon>person_remove</mat-icon>
              </button>
            </div>
          </td>

          <ng-container *ngFor="let perm of permissions; let i = index">
            <td class="perm-grid__perm-cell"
              [class.perm-grid__perm-cell--changed]="row.draft[perm.key] !== row.original[perm.key].checked">
              <mat-checkbox [(ngModel)]="row.draft[perm.key]" [attr.aria-label]="perm.label + ' for ' + row.usr_name"
                color="primary">
              </mat-checkbox>
              <span *ngIf="row.draft[perm.key] !== row.original[perm.key].checked" class="perm-grid__dirty-dot"
                matTooltip="Unsaved change" matTooltipPosition="above">
              </span>
            </td>
          </ng-container>

        </tr>

        <!-- Empty state -->
        <tr *ngIf="filteredRows.length === 0 && !loading">
          <td [colSpan]="permissions.length + 1" class="loading-wrapper" style="padding: 3rem 0;">
            <div><mat-icon color="primary" style="transform: scale(2); margin-bottom: 10px;">people_outline</mat-icon>
            </div>
            <div>No users match your search</div>
          </td>
        </tr>
      </tbody>

    </table>
  </div>

  <!-- ── Footer actions ─────────────────────────────────────────── -->
  <div class="panel-footer">
    <span class="panel-footer__hint" *ngIf="hasPendingChanges">
      <mat-icon>edit_note</mat-icon> You have unsaved changes
    </span>
    <span class="panel-footer__hint panel-footer__hint--none" *ngIf="!hasPendingChanges">
      No pending changes
    </span>


  </div>

</div>